import React from "react";
import ReactDOM from "react-dom/client";
import "./styles.css"; // Import your styles here
import App from "./App";

const GOOGLE_TAG_ID = process.env.REACT_APP_GOOGLE_TAG_ID;
const ADSENSE_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT;

function initGoogleTag(tagId) {
  if (!tagId) return;
  if (typeof window === "undefined" || typeof document === "undefined") return;

  if (window.gtag) return;

  const gtagScript = document.createElement("script");
  gtagScript.async = true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(tagId)}`;
  document.head.appendChild(gtagScript);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  window.gtag("js", new Date());
  window.gtag("config", tagId);
}

// Loads the AdSense script once, site-wide, but only once REACT_APP_ADSENSE_CLIENT
// is set (i.e. only after the AdSense application is approved). Until then this
// is a no-op, so no request to Google ever fires and nothing can look broken.
function initAdSense(client) {
  if (!client) return;
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (document.querySelector('script[data-adsense-loader="true"]')) return;

  const adsenseScript = document.createElement("script");
  adsenseScript.async = true;
  adsenseScript.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(client)}`;
  adsenseScript.crossOrigin = "anonymous";
  adsenseScript.dataset.adsenseLoader = "true";
  document.head.appendChild(adsenseScript);
}

initGoogleTag(GOOGLE_TAG_ID);
initAdSense(ADSENSE_CLIENT);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
